export const getMobilePlatform = () => {
  if (typeof window === "undefined") return "server";

  const ua = navigator.userAgent;

  if (/Android/i.test(ua)) {
    return "android";
  }

  if (/iPhone|iPad|iPod/i.test(ua)) {
    return "ios";
  }

  return "other";
};
